import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'
let companyInformation;

function Bestperformers() {
    const { BaseURL } = useContext(URLstateContext);
    const [dataBest, setDataBest] = useState([]);
    const [dataPer, setDataPer] = useState([]);
    const [valuebtn, setValueBtn] = useState("BSE");
    const [data, setData] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    // const [groupValue, setValueBtn] = useState("sebi");
    const [type, settype] = useState('bse');
    const [loadingshow, setloadingshow] = useState(false);

    let getData, getDataPer, getDataNew, getDataList;
    let navigate = useNavigate();
    let PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        if (valuebtn === "BSE") {
            const getUrlList = BaseURL + "BestPerformers";
            fetch(`${getUrlList}/BSE/main/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (valuebtn === "NSE") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/NSE/main/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (valuebtn === "bse") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/BSE/sme/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else if (valuebtn === "nse") {
            const getUrlNew = BaseURL + "BestPerformers";
            fetch(`${getUrlNew}/NSE/sme/8`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }
    }, [valuebtn]);

    const moreContent = () => {
        navigate("/IPO/Best-Performers")
    }

    // const handleSelect = (key) => {
    //     if (key === "bse")
    //         settype('bse');
    //     else
    //         settype('nse');
    // }


    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>Best Performers</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='ipo-common mf-common'>
                        <div>
                            <div className='NewListing'>
                                <button value="BSE" className={(valuebtn === "BSE") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BSE</button>
                                <button value="NSE" className={(valuebtn === "NSE") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NSE</button>
                                <button value="bse" className={(valuebtn === "bse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BSE SME</button>
                                <button value="nse" className={(valuebtn === "nse") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NSE EMERGE</button>
                            </div>
                        </div>
                        <div className='mf-table table-responsive gainer-table'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th className='text-left'>Company Name</th>
                                        <th className='text-right'>Listing Date</th>
                                        <th className='text-right'>Listing Price(&#8377;)</th>
                                        <th className='text-right'>Offer Price(&#8377;)</th>
                                        <th className='text-right'>LTP(&#8377;)</th>
                                        <th className='text-right'>High(&#8377;)</th>
                                        <th className='text-right'>Low(&#8377;)</th>
                                        <th className='text-right'>Volume</th>
                                        <th className='text-right'>Change(%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                    {(data != null) && data.map(
                                        ({ CO_NAME, LISTDATE, listprice, OfferPrice, CLOSE, HIGH, LOW, VOLUME, PerChange }) => (
                                            <tr>
                                                <td className="text-left">{CO_NAME} </td>
                                                <td className="text-right"> {(LISTDATE != null) ? LISTDATE.split('T')[0] : 0}</td>
                                                <td className="text-right"> {(listprice != null) ? listprice.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(OfferPrice != null) ? OfferPrice.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(CLOSE != null) ? CLOSE.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(HIGH != null) ? HIGH.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(LOW != null) ? LOW.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(VOLUME != null) ? VOLUME.toFixed(2) : 0}</td>
                                                <td className='text-right'>{(PerChange != null) ? PerChange.toFixed(2) : 0}</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }


                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Bestperformers;